import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

import * as deps from './dependencies';

Vue.config.devtools = true;

new Vue({
  router,
  store,
  beforeCreate() {
    console.log('------------------------- beforeCreate INITIALISE store -------------------------------');

    deps
      .loadFromDB()
      .then(() => {
        //deps.loadStore();
        //deps.saveToDB();
      })
      .catch(err => {
        console.error(err);
      });
    console.log('-------------------------- end INITIALISE ----------------------------');
  },
  render: h => h(App),
  created() {
    const watchers = this.$store._vm._computedWatchers;
    Object.keys(watchers).forEach(key => {
      watchers[key].watcherName = key;
    });
    console.log('Watchers:', watchers);
  },
}).$mount('#app');
